import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c31a3d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage-modal" }
const _hoisted_2 = { class: "search-modal-contain tw-flex tw-flex-col tw-gap-y-[20px]" }
const _hoisted_3 = { class: "tw-flex tw-flex-wrap md:tw-items-center tw-w-full tw-justify-between tw-items-center tw-gap-y-[15px]" }
const _hoisted_4 = { class: "tw-flex tw-flex-wrap md:tw-items-center md:tw-justify-end tw-gap-y-[15px]" }
const _hoisted_5 = { class: "filter-action" }

import HeaderModal from "@/components/common/headerModal.vue";
import { checkIsHavePermisstion, getComponentUiText } from "@/utils/utilities";
import ButtonBulkActions from "../common/setting/buttonBulkActions.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import FilterModal from "@/components/common/filter/filterModal.vue";
import { computed, ComputedRef, onMounted, ref, Ref, watch } from "vue";
import store from "@/store";
import { useRoute } from "vue-router";
import { IFilterSelect, IFilterTarget } from "@/interfaces/common/common";
import cloneDeep from "lodash/cloneDeep";


export default /*#__PURE__*/_defineComponent({
  __name: 'modalSearchAssessment',
  props: {
  seletedAssessmentRow: {
    type: Array,
    default: () => [],
  },
  originSelected: {
    type: Array as () => IFilterSelect[],
    default: () => [],
  },
  filterSelected: {
    type: Array as () => IFilterSelect[],
    default: () => [],
  },
  onInputModalFocus: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  "closeModal",
  "update:loading",
  "update:apply-filter",
  "clickOutside",
  "update:show-filter-modal",
],
  setup(__props, { emit }) {

const props = __props;




const isHavePermisstionShowMaster: Ref<boolean | undefined> = ref(false);
const checklistIdParam = ref<number>(0);
const route = useRoute();
const outsideFilterModal = ref(false);

const closeModal = () => {
  isShowFilterAction.value = false;
  emit("closeModal");
};

onMounted(async () => {
  checklistIdParam.value = Number(route.query.checklistId);
  isHavePermisstionShowMaster.value = await checkIsHavePermisstion(
    "assess_input__show_master_items",
  );
});

const onUpdateShowMasterItem = (value: boolean) => {
  emit("update:loading", true);

  store.dispatch("Assessment/updateShowMasterItems", value);

  const params = {
    checklistIdParam: checklistIdParam.value,
    showMasterItem: value,
  };
  store.dispatch("Assessment/fetchChecklistByCategory", params);
  emit("update:loading", false);
};
const progressCategories = computed(() => store.state.Assessment.categories);

//#region Filter
const fiterTargetOption: ComputedRef<IFilterTarget[]> = computed(() => [
  {
    targetId: "itemCompleteValue",
    targetText:
      "app-component-assessment-display-options-filter-hide-complete-1",
    values: [
      {
        id: 0,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-hide-complete-option-A-1",
        ),
        isHardText: true,
      },
      {
        id: 1,
        isDefault: true,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-hide-complete-option-B-1",
        ),
        isHardText: true,
      },
    ],
    isRadio: true,
  },
  {
    targetId: "visibleState",
    targetText:
      "app-component-assessment-display-options-filter-show-excluded-1",
    values: [
      {
        id: 1,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-show-excluded-option-B-1",
        ),
        isHardText: true,
      },
      {
        id: 0,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-show-excluded-option-A-1",
        ),
        isHardText: true,
      },
    ],
    isRadio: true,
  },
  {
    targetId: "checklistItemCategoryId",
    targetText:
      "app-component-assessment-display-options-filter-show-category-1",
    values: progressCategories.value.map((category) => ({
      id: category.checklistItemCategoryId,
      text: category.checklistItemCategoryLabel,
      isDefault: false,
      isHardText: true,
    })),
    isRadio: true,
  },
  {
    targetId: "score-increase",
    order: 4,
    targetText:
      "app-component-assessment-display-options-filter-score-increase-1",
    values: [
      {
        id: 1,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-above-1",
        ),
        isHardText: true,
        type: "input",
        hindText: "",
      },
      {
        id: 0,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-below-1",
        ),
        isHardText: true,
        type: "input",
        hindText: "",
      },
    ],
    isRadio: false,
    isNotClear: true,
  },
  {
    targetId: "itemCompleteValue-percentage",
    order: 4,
    targetText:
      "app-component-assessment-display-options-filter-compliance-percentage-1",
    values: [
      {
        id: 1,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-above-1",
        ),
        isHardText: true,
        hindText: "%",
        type: "input",
      },
      {
        id: 0,
        text: getComponentUiText(
          "app-component-assessment-display-options-filter-compliance-percentage-option-below-1",
        ),
        isHardText: true,
        hindText: "%",
        type: "input",
      },
    ],
    isRadio: false,
    isNotClear: true,
  },
]);

const isShowFilterAction = ref(false);
const handleShowFilterAction = () => {
  if (isShowFilterAction.value) {
    outsideFilterModal.value = true;
  } else {
    isShowFilterAction.value = !isShowFilterAction.value;
    emit("update:show-filter-modal", isShowFilterAction.value);
  }
};
watch(
  () => props.onInputModalFocus,
  (newValue) => {
    if (props.onInputModalFocus) {
      isShowFilterAction.value = false;
    }
  },
  { immediate: true },
);
const handleApplyFilter = (data: any) => {
  outsideFilterModal.value = false;
  isShowFilterAction.value = false;
  emit("update:apply-filter", data);
};
//#endregion Filter

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeaderModal, {
        "header-text": 
        _unref(getComponentUiText)(
          'app-component-search-box-assessment-search-button-1',
        )
      ,
        class: "!tw-px-[20px] md:!tw-px-[40px]",
        onCloseModal: closeModal
      }, null, 8, ["header-text"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "searchFilter"),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(ButtonBulkActions, {
            active: __props.seletedAssessmentRow?.length > 0,
            "is-margin-right": false,
            "selected-number": __props.seletedAssessmentRow?.length
          }, null, 8, ["active", "selected-number"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(ButtonFilter, {
              active: fiterTargetOption.value.length > 0,
              "is-filter": 
              __props.originSelected.filter((item) => !item.value.isDefault).length > 0
            ,
              "show-more-actions": isShowFilterAction.value,
              "id-popover": 'popoverBtnFilterMainAssessmentSearch',
              "is-margin-right": false,
              "button-class": "!tw-h-[46px] tw-ml-5",
              onClickAway: _cache[0] || (_cache[0] = ($event: any) => (outsideFilterModal.value = true)),
              onClick: handleShowFilterAction
            }, {
              default: _withCtx(() => [
                _createVNode(FilterModal, {
                  targets: fiterTargetOption.value,
                  "is-date": false,
                  "is-search": false,
                  "show-more-actions": isShowFilterAction.value,
                  "filter-selected": __props.filterSelected,
                  "outside-filter-modal": outsideFilterModal.value,
                  "original-data": {
                filterSelected: _unref(cloneDeep)(__props.originSelected),
              },
                  "onUpdate:applyFilter": handleApplyFilter
                }, null, 8, ["targets", "show-more-actions", "filter-selected", "outside-filter-modal", "original-data"])
              ]),
              _: 1
            }, 8, ["active", "is-filter", "show-more-actions"])
          ])
        ])
      ]),
      _renderSlot(_ctx.$slots, "listFilter")
    ])
  ], 64))
}
}

})